import { render, staticRenderFns } from "./SubItem.vue?vue&type=template&id=8e77201a&scoped=true"
import script from "./SubItem.vue?vue&type=script&lang=js"
export * from "./SubItem.vue?vue&type=script&lang=js"
import style0 from "./SubItem.vue?vue&type=style&index=0&id=8e77201a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e77201a",
  null
  
)

export default component.exports